<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>报名详细信息</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="right" @click="$router.back(-1)">
                <button class="swb-btn swb-btn-link"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
            </div>
        </div>

        <div class="bidding-container" style="width: 1100px; margin: 0 auto;padding: 10px;background-color: #f1f1f1">
            <h1 class="main-subtitle"> 招标书标题： {{bidEnrollInfo.title}}</h1>
            <div class="bidding-details">
                <div class="form-single">
                    <div class="title">联系人名：</div>
                    <div class="content">
                        <label class="mr20">{{bidEnrollInfo.contactName}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">联系电话：</div>
                    <div class="content">
                        <label class="mr20">{{bidEnrollInfo.contactTel}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">联系电子邮箱：</div>
                    <div class="content">
                        <label class="mr20">{{bidEnrollInfo.contactEmail}}</label>
                    </div>
                </div>

                <div class="content-caption dashed font18" style="background-color: #fff">
                    <span><span class="color-laber"></span>报名的资质</span>
                </div>
                <table class="custom-tbl">
                    <thead class="head align-left">
                    <tr class="row">
                        <th>招标资质组号</th>
                        <th>招标资质名称</th>
                        <th>招标资质类型</th>
                        <th>是否必须</th>
                    </tr>
                    </thead>
                    <tbody class="body">
                    <tr class="row" v-for="merchantQuali in bidEnrollQualiList">
                        <td>
                            <span>{{merchantQuali.groupNo}}</span>
                        </td>
                        <td class="align-left" :class="{ selected : merchantQuali.qualiId != null}">
                            <span>{{merchantQuali.callQualiTypeName}}</span>
                        </td>
                        <td>
                            <span>{{qualiKindList[merchantQuali.callQualiKind].text}}</span>
                        </td>
                        <td>
                            <div class="table-addr">
                                <el-radio-group disabled v-model="merchantQuali.callMandatory">
                                    <el-radio :label=false>否</el-radio>
                                    <el-radio :label=true>是</el-radio>
                                </el-radio-group>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="content-caption dashed">
                    <span><span class="color-laber"></span>要求的人员资质</span>
                </div>
                <table class="custom-tbl">
                    <thead class="head align-left">
                    <tr class="row">
                        <th>资质类型</th>
                        <th>类型名称</th>
                        <th>类型等级（及以上）</th>
                        <th>是否必须</th>
                        <th>要求数量</th>
                        <th>资质数量</th>
                    </tr>
                    </thead>
                    <tbody class="body align-left">
                    <tr class="row" v-for="staffQuali in staffQualiList">
                        <td class="align-left">{{staffQuali.name}}</td>
                        <td class="align-left">{{staffQuali.qualiName}}</td>
                        <td>
                            <div class="table-addr">
                                <span v-if="staffQuali.qualiLevel == 1">一级</span>
                                <span v-if="staffQuali.qualiLevel == 2">二级</span>
                                <span v-if="staffQuali.qualiLevel == 3">三级</span>
                                <span v-if="staffQuali.qualiLevel == 4">四级</span>
                                <span v-if="staffQuali.qualiLevel == 5">五级</span>
                            </div>
                        </td>
                        <td>
                            <div class="table-addr">
                                <span v-if="staffQuali.mandatory">是</span>
                                <span v-else>否</span>
                            </div>
                        </td>
                        <td>{{staffQuali.quantity}}</td>
                        <td>
                            <span v-if="staffQuali.mandatory && staffQuali.quantity &gt; staffQuali.staffQualiQuantity" class="font-red">{{staffQuali.staffQualiQuantity}}</span>
                            <span v-if="!staffQuali.mandatory && staffQuali.quantity &gt; staffQuali.staffQualiQuantity" class="font-gold">{{staffQuali.staffQualiQuantity}}</span>
                            <span v-if="staffQuali.quantity &lt;= staffQuali.staffQualiQuantity">{{staffQuali.staffQualiQuantity}}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="content-caption dashed font18" style="background-color: #fff">
                    <span><span class="color-laber"></span>报名附件</span>
                </div>
                <div class="form-single">
                    <div class="content" style="padding-left: 38px;">
                        <div class="file-area clearfix">
                            <div class="file-area clearfix">
                                <swb-file-item v-for="(file, index) in bidEnrollInfo.bidEnrollFileList" :trackKey="index" :fileName="file.name" :fileUuid="file.fileUuid" :fileBrowseUrl="file.fileBrowseUrl" :fileDownloadUrl="file.fileDownloadUrl" :fileMd5="file.fileMd5"></swb-file-item>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <span v-if="bidEnrollInfo.resultFlag == 0">
                        <a class="swb-btn mr10" @click="AuditBidEnroll(bidEnrollInfo.id, 1, bidEnrollInfo.callDocId)">审核通过</a>
                        <a class="swb-btn" @click="AuditBidEnroll(bidEnrollInfo.id, -1, bidEnrollInfo.callDocId)">审核不通过</a>
                    </span>
                    <span v-if="bidEnrollInfo.resultFlag == 1">
                        <a class="swb-btn mr10">已通过审核</a>
                    </span>
                    <span v-if="bidEnrollInfo.resultFlag == -1">
                        <a class="swb-btn">未通过审核</a>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import callBidApi from '../../api/callBid'
    import tendBidApi from '../../api/tendBid'

    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);

    import SwbQualiAttrValSearch from '../quali/QualiAttrValSearch';
    Vue.regist(SwbQualiAttrValSearch);

    import SwbBidEnrollList from './BidEnrollList';
    Routes.add(SwbBidEnrollList);

    function sortCallBidReqQuali(itemList) {
        itemList.sort(function (item1, item2) {
            var retValue = item1['groupNo'] - item2['groupNo'];
            if(retValue == 0) {
                retValue = item1['seqNo'] - item2['seqNo']
            }
            return retValue;
        });
        return itemList;
    }

    export default{
        name: 'swb-bid-enroll-info',
        path: '/tend/bid/enroll/detail',
        pathOld: '/bid/enroll/info/to',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '报名书详情',
        data: function () {
            return {
                bidEnrollInfo: {},
                groupNoQualiIdsMap: {},
                bidEnrollQualiList: [],
                qualiKindList: [],
                //
                staffQualiList: {},
            }
        },
        created: function () {
            this.qualiKindList = getEnumList("qualiKind");
            this.getBidEnrollList();
        },
        methods: {
            downloadFile: function (fileDownLoadUrl) {
                Utils.downloadFile(getAppUrl(fileDownLoadUrl));
            },
            viewImage: function (fileBrowseUrl) {
                Utils.setPageUrl(fileBrowseUrl, '_blank');
            },
            //
            getBidEnrollList: function () {
                let self = this;
                let bidEnrollId = this.$route.query.bidEnrollId;
                let lastMsgBoxDlg = MsgBox.loading();
                tendBidApi.getBidEnrollInfo(bidEnrollId, function (result) {
                    if(result.type == 'info') {
                        let bidEnrollInfo = result.data;
                        let bidEnrollQualiList = bidEnrollInfo.bidEnrollQualiList;
                        if(bidEnrollQualiList.length > 0) {
                            bidEnrollQualiList = sortCallBidReqQuali(bidEnrollQualiList);
                        }
                        self.bidEnrollQualiList = bidEnrollQualiList;
                        self.bidEnrollInfo = bidEnrollInfo;
                        console.log(bidEnrollInfo);
                        //
                        self.getCallBidDocInfoForStaffQuali(bidEnrollInfo.callDocId, bidEnrollInfo.merchantId, bidEnrollInfo.merchantType);
                    } else {
                        MsgBox.warning(result.message);
                    }
                    lastMsgBoxDlg.close();
                });
            },
            getCallBidDocInfoForStaffQuali: function (callDocId, peerMerchantId, peerMerchantType) {
                let self = this;
                let postData = {};
                postData.callBidDocId = callDocId;
                postData.peerMerchantId = peerMerchantId;
                postData.peerMerchantType = peerMerchantType;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidDocInfoForStaffQuali(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        //
                        self.staffQualiList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 审核
            AuditBidEnroll: function (enrollId, auditState, docId) {

                let self = this;
                this.$confirm('确认提交吗?', '提交审核', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({value}) => {
                    let postData = {};
                    postData.id = enrollId;
                    postData.auditState = auditState;
                    postData.auditDesc = value;
                    let theLoad = MsgBox.loading();
                    tendBidApi.updateBidEnrollResultFlag(postData, function (result) {
                        if(result.type == 'info') {
                            //
                            self.toBidEnrollList(docId);
                        } else {
                            MsgBox.warning(result.message);
                        }
                        theLoad.hide();
                    });
                }).catch(() => {
                });
            },
            // 返回报名列表
            toBidEnrollList: function (id) {
                this.$router.push({
                    path: SwbBidEnrollList.path,
                    query: {
                        docId: id,
                        checkState: 3,
                    }
                });
            },

            downloadDemoFile: function (fileDownloaddUrl) {
                Utils.downloadFile(getAppUrl(fileDownloaddUrl));
            },
        }
    }

</script>
<style scoped>
    .selected {
        color: green;
    }

</style>



// WEBPACK FOOTER //
// src/compo/callbid/BidEnrollInfo.vue